const GetEndpoint = `
  query Query($id: String!) {
    endpoint(id: $id) {
      id,
      name,
      description,
      type,
      config {
        ... on SFTPEndpointConfig {
          hostname
          username
          sshKey {
            secretArn
            secretKey
          }
          password {
            secretArn
            secretKey
          }
          prefix
        }
        ... on HTTPEndpointConfig {
          url
          port
          password {
            secretArn
            secretKey
          }
          headers {
            key
            value
          }
        }
        ... on BlobEndpointConfig {
          container
          accountName
          prefix
          region
        }
        ... on S3EndpointConfig {
          bucket
          assumeRoleARN
          prefix
          region
        }
        ... on EmailEndpointConfig {
          fromAddress
        }
      }
    }
  }
`

const GetEndpoints = 
  `query Query($count: Int, $cursor: String, $filterConfig: EndpointFilterConfigInput) {
    endpoints(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          description
          type
          config {
            ... on SFTPEndpointConfig {
              hostname
              username
              sshKey {
                secretArn
                secretKey
              }
              password {
                secretArn
                secretKey
              }
            }
            ... on S3EndpointConfig {
              bucket
              assumeRoleARN
              prefix
              region
            }
          }
        }
      }
    }
  }  
  `

module.exports = {
  GetEndpoint,
  GetEndpoints,
}
